import { makeAutoObservable } from 'mobx';

import http from '../helpers/http';

import Court from './models/Court';

export default class CourtStore {
    constructor() {
        makeAutoObservable(this);
    }

    static async find() {
        const { data } = await http.get('/courts?filters[populate][]=players&size=10');
        return data.courts.map((court: any) => new Court().fromJSON(court)) as Court[];
    }

    static async saveById(id: string, formData: any) {
        const { data } = await http.put(`/courts/${id}`, formData);
        return new Court().fromJSON(data);
    }
}
